import React from 'react';
import { Layout, Splitter, Skeleton, Space, Divider, Row, Col } from 'antd';
import { useInboxV2Styles } from '../inbox-v2/inboxv2-styles';

const styles = {
    container: {
        height: 'calc(100vh - 60px)',
        backgroundColor: '#fff',
        overflow: 'hidden'
    },
    leftPanel: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #f0f0f0'
    },
    header: {
        padding: '16px 16px',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#fcfdfa'
    },
    rightPanel: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
};

const UserProfileSkeleton = () => {
    // Re-use styles logic to match precise dimensions/padding
    const { contentStyle, headerStyle, textingInputAreaStyle } = useInboxV2Styles({ hasScheduling: false });

    return (
        <div style={styles.container}>
            <Splitter>
                <Splitter.Panel defaultSize="60%" min="30%" max="60%">
                    <div style={styles.leftPanel}>
                         {/* Header Skeleton */}
                        <div style={styles.header}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Skeleton.Input active size="default" style={{ width: 200, height: 28 }} />
                                <Space>
                                    <Skeleton.Button active size="small" shape="square" />
                                    <Skeleton.Button active size="small" shape="square" />
                                    <Skeleton.Button active size="small" shape="square" />
                                </Space>
                            </div>
                            <div style={{ marginTop: 12 }}>
                                 <Space>
                                    <Skeleton.Button active size="small" style={{ width: 60, height: 22, borderRadius: 4 }} />
                                    <Skeleton.Button active size="small" style={{ width: 80, height: 22, borderRadius: 4 }} />
                                 </Space>
                            </div>
                        </div>

                        {/* Body Split: Tabs (approx 124px) + Content */}
                        <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                            {/* Fake Tabs Sidebar */}
                            <div style={{ width: 124, borderRight: '1px solid #f0f0f0', paddingTop: 8 }}>
                                <div style={{ padding: '12px 16px' }}><Skeleton.Button active size="small" style={{ width: 60 }} block /></div>
                                <div style={{ padding: '12px 16px' }}><Skeleton.Button active size="small" style={{ width: 70 }} block /></div>
                                <div style={{ padding: '12px 16px' }}><Skeleton.Button active size="small" style={{ width: 65 }} block /></div>
                            </div>
                            
                            {/* Form Content Area */}
                            <div style={{ flex: 1, padding: 24, overflow: 'hidden' }}>
                                <Skeleton active paragraph={{ rows: 0 }} title={{ width: 150 }} /> {/* "Contact Information" */}
                                
                                <Row gutter={12} style={{ marginTop: 20 }}>
                                    <Col span={12}>
                                        <Skeleton.Input active block style={{ height: 32, marginBottom: 24 }} />
                                    </Col>
                                    <Col span={12}>
                                        <Skeleton.Input active block style={{ height: 32, marginBottom: 24 }} />
                                    </Col>
                                </Row>
                                <Row gutter={12}>
                                    <Col span={12}>
                                        <Skeleton.Input active block style={{ height: 32, marginBottom: 24 }} />
                                    </Col>
                                    <Col span={12}>
                                        <Skeleton.Input active block style={{ height: 32, marginBottom: 24 }} />
                                    </Col>
                                </Row>

                                <Divider style={{ margin: '24px 0' }} />

                                <Skeleton active paragraph={{ rows: 0 }} title={{ width: 180 }} /> {/* "Additional Information" */}
                                <div style={{ marginTop: 20 }}>
                                    <Skeleton.Input active block style={{ height: 60, marginBottom: 16 }} /> {/* Notes */}
                                    <Skeleton.Input active block style={{ height: 32, marginBottom: 16 }} />
                                    <Skeleton.Input active block style={{ height: 32, marginBottom: 16 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Splitter.Panel>
                
                <Splitter.Panel defaultSize="40%" min="40%">
                    <div style={styles.rightPanel}>
                         {/* Right Header */}
                        <div style={{ ...headerStyle, padding: '0 24px', display: 'flex', alignItems: 'center' }}>
                            <Skeleton.Input active size="small" style={{ width: 120 }} />
                        </div>

                        {/* Thread List Area */}
                        <div style={{ ...contentStyle, backgroundColor: '#fafafa', padding: 20, flex: 1, overflow: 'hidden' }}>
                            {[1, 2, 3].map((i) => (
                                <div key={i} style={{ display: 'flex', flexDirection: i % 2 === 0 ? 'row-reverse' : 'row', marginBottom: 24 }}>
                                    <Skeleton.Avatar active shape="circle" size="default" style={{ margin: '0 12px' }} />
                                    <div style={{ 
                                        width: '60%', 
                                        height: 60, 
                                        background: '#eee', 
                                        borderRadius: 8,
                                        opacity: 0.5 
                                    }} />
                                </div>
                            ))}
                        </div>

                         {/* Input Area */}
                         <div style={textingInputAreaStyle}>
                             <Skeleton.Input active block style={{ height: 40, borderRadius: 20 }} />
                         </div>
                    </div>
                </Splitter.Panel>
            </Splitter>
        </div>
    );
};

export default UserProfileSkeleton;
